export default __webpack_public_path__ + "images/d69b1a8192c0e09d41ae46c77f98dab1.png";